var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMouseGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6958 13.8269L13.8268 3.69586L17.9017 7.77077C20.6993 10.5684 20.6993 15.1042 17.9017 17.9018C15.1041 20.6994 10.5683 20.6994 7.77071 17.9018L3.6958 13.8269Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2292 2.0982L12.7543 2.6233L2.6233 12.7543L2.0982 12.2292C-0.699401 9.43163 -0.699401 4.89581 2.0982 2.0982C4.89581 -0.699401 9.43163 -0.699401 12.2292 2.0982ZM4.19091 4.19096C3.88509 4.49678 3.88509 4.99261 4.19091 5.29843L5.68892 6.79644C5.99474 7.10226 6.49057 7.10226 6.79639 6.79644C7.10221 6.49063 7.10221 5.9948 6.79639 5.68898L5.29837 4.19096C4.99255 3.88514 4.49672 3.88514 4.19091 4.19096Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseGrey);
export default __webpack_public_path__ + "static/media/Mouse_grey.b7b239cd3ac6d43c695d5a4052453561.svg";
export { ForwardRef as ReactComponent };